import { animateIn, animateOut } from '../utility/animate.js'

function brandModal(el) {
    // TODO: Setup accessibility focus jump
    const body = document.querySelector('body')
    const modal = document.querySelector('.modal')
    const modalInner = document.querySelector('.modal__inner')
    const modalOverlay = document.querySelector('.modal__overlay')

    const brandItems = [...el.querySelectorAll('.brand-grid__item')]

    let content = ''

    let isActive = false

    function close() {
        isActive = false
        body.classList.remove('overflow-fixed')

        animateOut(modal)

        // modalInner.innerHTML = ''
        // content = ''

        // TODO: Remove content after delay to avoid jump
    }

    function open(item) {
        isActive = true
        body.classList.add('overflow-fixed')

        content = item.querySelector('.brand-grid__modal').innerHTML;
        modalInner.innerHTML = content
        animateIn(modal)

        let modalClose = modal.querySelector('.modal__close')

        modalClose.addEventListener('click', close)

    }

    function toggle(item) {
        isActive ? close() : open(item)
    }

    brandItems.map(item => {
        item.addEventListener('click', () => toggle(item));
    })

    modalOverlay.addEventListener('click', close)


    // detect esc key
    window.addEventListener('keydown', event => {
        const escKey = (event.key === 'Escape' || event.keyCode === 27)
        // const isActive = el.classList.contains('active')
        if (isActive && escKey) toggle()
    })
}


[...document.querySelectorAll('.brand-grid')].map(brandModal)
